import * as Clipboard from 'expo-clipboard'
import { Box, Pressable, Row, Text } from 'native-base'
import { useCallback } from 'react'

import { Icon } from './Icon'

import { useToast, useTranslation } from '~hooks'
type CodeBoxType = {
  code: string
  isUsed?: boolean
  solidBorder?: boolean
}

export const OfferCodeBox = ({ code, isUsed = false, solidBorder = false }: CodeBoxType) => {
  const properColor = isUsed ? 'offMain' : 'actionBlue'
  const { showToast } = useToast()
  const { t } = useTranslation()

  const copyToClipboard = useCallback(async () => {
    if (isUsed) {
      return
    }
    await Clipboard.setStringAsync(code)
    showToast({ description: t('toast_messages.coupon_copied'), variant: 'info' })
  }, [isUsed, code, t, showToast])

  return (
    <Pressable onPress={copyToClipboard}>
      <Row
        borderColor={properColor}
        borderRadius="lg"
        borderStyle={solidBorder ? 'solid' : 'dashed'}
        borderWidth="1"
        p="5"
      >
        <Text
          bold
          color={properColor}
          flexWrap="wrap"
          fontSize="2xl"
          numberOfLines={1}
          pr={isUsed ? 0 : 6}
        >
          {code}
        </Text>
        {!isUsed && (
          <Box alignSelf="center" ml="auto">
            <Icon name="file-copy-line" size={25} />
          </Box>
        )}
      </Row>
    </Pressable>
  )
}
